import '../scss/main.scss';
import '../scss/resources.scss';
import '../scss/details.scss';

// JS
import 'bootstrap';
import './accordion.js';
import './admin-related-articles';
import './author-reviewer-modal.js';

console.log('Webpack is working!');
